var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "header-box model",
      style: {
        borderTopLeftRadius: _vm.borderRadius,
        borderTopRightRadius: _vm.borderRadius
      }
    },
    [
      _c("div", { staticClass: "left" }, [
        _c("img", { staticClass: "icon", attrs: { alt: "" } }),
        _vm._v(" "),
        _c("span", { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "right" },
        [
          _vm._l(_vm.topBtns, function(item, index) {
            return [
              (item.show == false
              ? false
              : true)
                ? _c(
                    "el-button",
                    {
                      directives: [{ name: "reClick", rawName: "v-reClick" }],
                      key: index,
                      attrs: {
                        plain: item.plain || true,
                        type: item.type || "primary",
                        icon: item.icon || "",
                        size: item.size || "medium",
                        disabled: item.disabled || false
                      },
                      on: {
                        click: function($event) {
                          return _vm.topOperation(item.text, item.event)
                        }
                      }
                    },
                    [_vm._v(_vm._s(item.text))]
                  )
                : _vm._e()
            ]
          })
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-103efd58", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-103efd58","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EXDetail/EXHeader.vue
// module id = 375
// module chunks = 0